import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { BlogFaqItem } from "../types";

const BlogFaq = ({ faqs }: { faqs: BlogFaqItem[] }) => {
  const [showAll, setShowAll] = useState(false);
  const visibleFaqs = showAll ? faqs : faqs.slice(0, 4);

  return (
    <section className="blog-faq" aria-labelledby="blog-faq-title">
      <h2 id="blog-faq-title">Frequently Asked Questions</h2>
      <div>
        {visibleFaqs.map((faq) => (
          <Accordion key={faq.question} elevation={0} className="blog-faq__item">
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              {faq.question}
            </AccordionSummary>
            <AccordionDetails>
              <p>{faq.answer}</p>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
      {faqs.length > 4 && (
        <button className="blog-text-link" type="button" onClick={() => setShowAll(!showAll)}>
          {showAll ? "Show Fewer Questions" : "View More Questions"} <span aria-hidden="true">→</span>
        </button>
      )}
    </section>
  );
};

export default BlogFaq;
